import * as React from "react";
import { Dialog } from "../dialog";

type ActionModalProps = {
  open: boolean;
  content: React.ReactNode;
  onOpenChange?: (open: boolean) => void;
  onClose?: () => void;
};

export const ActionModal = ({
  open,
  content,
  onOpenChange,
  onClose,
}: ActionModalProps) => {
  const handleOpenChange = (value: boolean) => {
    onOpenChange?.(value);
    if (!value && onClose) {
      onClose();
    }
  };

  return <Dialog open={open} onOpenChange={handleOpenChange}>{content}</Dialog>;
};
